import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  paper: {
    fontFamily: `'Manrope', sans-serif`,
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    width: "70vw",
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    // padding: "1.5rem",
    [theme.breakpoints.down("md")]: {
      width: "85vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  modalBody: {
    height: "100%",
    width: "100%",
    position: "relative",
    "@media (min-height: 750px)": {
      overflowX: "hidden",
    },
    "& button": {
      fontFamily: `'Manrope', sans-serif`,
    },
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
    padding: "1.5rem",
    paddingBottom: 0,
  },
  modalHeaderTitle: {
    marginBottom: 0,
    fontSize: 24,
    lineHeight: "28px",
    color: "#232325",
    fontWeight: 800,
  },
  modalHeaderSubtitle: {
    fontSize: 14,
    lineHeight: "24px",
    color: "#6F727A",
    fontWeight: "normal",
  },
  modalSection: {
    padding: "1.5rem",
    paddingTop: 0,
    "&.fullForm": {
      maxHeight: "55vh",
      overflowY: "auto",
    },
  },
  modalFooter: {
    background: "#F7F7F9",
    height: 80,
    padding: "16px 1.5rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    borderRadius: "0 0 8px 8px",
  },
  contactsModalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    backgroundColor: "#FFF",
    width: "75vw",
    maxHeight: "90vh",
    overflow: "auto",
    transform: "translate(-50%, -50%)",
    borderRadius: "12px",
  },

  contactsModalContent: {
    padding: "0 40px",
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 0",
  },

  contactModalTitle: {
    color: "#232325",
    fontWeight: 800,
    fontSize: "20px",
    lineHeight: "28px",
  },

  count: {
    background: getBrandCustom("primaryColor", "#38cfc4"),
    color: "#FFF",
    fontSize: "10px",
    fontWeight: 600,
    borderRadius: "16px",
    padding: "4px 6px",
    marginLeft: "16px",
    marginTop: 2,
    lineHeight: "10px",
    fontFamily: `'Manrope', sans-serif`,
  },

  contactsList: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "60vh",
    overflowY: "scroll",
    marginTop: "20px",
  },

  contactLine: {
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",

    "& span": {
      color: "#667085",
      margin: "0 16px",
      fontSize: "14px",
      lineHeight: "24px",
    },
  },

  contactsButtonsContainer: {
    background: "#F7F7F9",
    display: "flex",
    justifyContent: "flex-end",
    padding: "16px 40px",
    borderRadius: "0 0 12px 12px",
    alignSelf: "flex-end",
  },

  buttonClose: {
    fontSize: "16px",
    fontWeight: 700,
  },
}));

export default styles;
